import { render, staticRenderFns } from "./DateInputDemo.vue?vue&type=template&id=0d8b8722"
import script from "./DateInputDemo.vue?vue&type=script&lang=js"
export * from "./DateInputDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports